/**
 * SecondAura : un clic sur le logo recharge la page d'accueil, en haut, depuis n'importe quelle page.
 *
 * Le logo est un lien vers l'accueil. Quand on y était déjà, Safari rechargeait la page, la remettait à l'ancienne
 * position de défilement, puis la faisait glisser vers le haut (effet « remonte et recharge »). On marque donc le
 * départ depuis le logo, et la page d'accueil qui arrive s'ouvre tout en haut, d'un coup, sans glisser.
 */

const CLE = 'sa-logo-accueil';

/** Toutes les manières dont la page peut défiler : la fenêtre (téléphone) et le cadre de la page (ordinateur). */
function conteneurs() {
  return [document.scrollingElement, document.querySelector('.page-wrapper')].filter((el) => el instanceof Element);
}

/** Met la page tout en haut, d'un coup (le thème fait glisser les défilements par défaut, voir base.css). */
function enHautDUnCoup() {
  for (const el of conteneurs()) el.scrollTo({ top: 0, behavior: 'instant' });
}

// Arrivée sur la page après un clic sur le logo.
let arriveeDepuisLogo = false;
try {
  // Le repère est daté : il ne vaut que pour un départ récent (un appui sur le logo sans suite ne compte pas plus tard).
  arriveeDepuisLogo = Date.now() - Number(sessionStorage.getItem(CLE) || 0) < 10000;
  sessionStorage.removeItem(CLE);
} catch (_) {
  // Stockage indisponible (navigation privée stricte) : la page s'ouvre normalement.
}

if (arriveeDepuisLogo) {
  history.scrollRestoration = 'manual';
  // Le thème remet au chargement la position enregistrée dans l'historique (voir scroll-container.js) : on l'efface.
  try {
    const etat = typeof history.state === 'object' && history.state !== null ? history.state : {};
    history.replaceState({ ...etat, scrollTop: 0 }, '');
  } catch (_) {
    // État trop gros : le maintien en haut ci-dessous suffit.
  }

  // Pendant le chargement, rien ne glisse, et on garde la page en haut si le navigateur tente d'y revenir.
  const styles = conteneurs().map((el) => [el, el.style.scrollBehavior]);
  for (const [el] of styles) el.style.scrollBehavior = 'auto';
  enHautDUnCoup();
  const maintenir = () => requestAnimationFrame(enHautDUnCoup);
  window.addEventListener('pageshow', maintenir);
  window.addEventListener('load', maintenir);

  // On rend la main au visiteur dès qu'il fait défiler lui-même, et au plus tard après le chargement.
  const liberer = () => {
    window.removeEventListener('pageshow', maintenir);
    window.removeEventListener('load', maintenir);
    for (const [el, valeur] of styles) el.style.scrollBehavior = valeur;
  };
  for (const evenement of ['wheel', 'touchstart', 'keydown']) {
    window.addEventListener(evenement, liberer, { once: true, passive: true });
  }
  window.addEventListener('load', () => setTimeout(liberer, 500), { once: true });
}

/**
 * Prépare le départ depuis le logo : repère pour la page d'arrivée, et position « tout en haut » dans l'historique.
 * @param {Event} event
 * @returns {HTMLAnchorElement | null} le lien du logo, s'il s'agit bien de lui
 */
function preparerDepart(event) {
  if (event.defaultPrevented) return null;
  if (event instanceof MouseEvent && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) {
    return null;
  }

  const lien = event.target instanceof Element ? event.target.closest('a.header-logo') : null;
  if (!(lien instanceof HTMLAnchorElement)) return null;
  if (new URL(lien.href, window.location.href).origin !== window.location.origin) return null;

  try {
    sessionStorage.setItem(CLE, String(Date.now()));
  } catch (_) {
    // Stockage indisponible : on recharge quand même l'accueil.
  }
  history.scrollRestoration = 'manual';
  // Le thème enregistre la position au départ (pagehide) : on la remplace par « tout en haut » juste après lui.
  window.addEventListener('pagehide', effacerPosition, { once: true });
  return lien;
}

function effacerPosition() {
  try {
    const etat = typeof history.state === 'object' && history.state !== null ? history.state : {};
    history.replaceState({ ...etat, scrollTop: 0 }, '');
  } catch (_) {
    // État trop gros : l'arrivée remettra quand même la page en haut.
  }
}

// Safari peut quitter la page dès l'appui, avant le « clic » : on prépare donc le départ dès ce moment-là.
document.addEventListener('pointerdown', preparerDepart, true);

document.addEventListener('click', (event) => {
  // Clic normal uniquement : avec Ctrl, Maj ou la molette, on laisse le lien s'ouvrir ailleurs.
  const lien = preparerDepart(event);
  if (!lien) return;

  event.preventDefault();
  window.location.assign(lien.href);
});
